import {Box, Divider, Typography} from '@mui/material';
import {t} from 'i18next';
import {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import AurStepper from '../../../common/aur-stepper-tab/AurStepperTab';

import CustomIndexGeneralInfo from './CustomIndexGeneralInfo';
import {RootState} from '../../../../redux/store';
import CustomIndexFormStep2 from './CustomIndexFormStep2';
import ConfigureIndexStep4 from './ConfigureIndexStep4';
import {
  resetCreateCustomIndex,
  setConfirmModal,
} from '../../../../redux/slices/indexingSlice';
import CutomIndexStep3 from './CustomIndexStep3';
import {ReactComponent as BackgroundImage} from '../../../../assests/svg/glow-right.svg';
import IndexBreadCrumbs from '../../indexBreadCrums';
import AurPopup from '../../../common/aur-popup/AurPopup';
import {useNavigate} from 'react-router-dom';
import {EciHomePageTabs} from '../../../../constants/constants';

const CustomIndexStep1: React.FC = () => {
  const steps = [
    {label: t('wizard.generalInfo')},
    {label: t('wizard.addMetadataFields')},
    {label: t('wizard.analyzerInformation')},
    {label: t('wizard.configureIndex')},
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);

  const [clickedItem, setClickedItem] = useState<string | null>(null);

  const handleBreadcrumbClick = (itemKey: string) => {
    setClickedItem(itemKey);
    handlePopup();
  };

  const handlePopup = () => {
    dispatch(setConfirmModal(true));
  };

  useEffect(() => {
    dispatch(setConfirmModal(false));
  }, []);

  const breadCrumArray = [
    {key: '1', value: t('eca.ecaHomepage.coreEciHome')},
    {key: '2', value: t('ecaIndexing.manageIndexes')},
  ];

  const selectedFieldsCount = useSelector(
    (state: RootState) => state.indexes.selectedFieldsCount
  );

  const showPopup = useSelector(
    (state: RootState) => state.indexes.confirmModal
  );

  const handleContinueOptionSelected = () => {
    dispatch(setConfirmModal(false));
    dispatch(resetCreateCustomIndex());
    if (clickedItem == '1') {
      navigate(`/eci-home-page?tab=${EciHomePageTabs.ECI_OVERVIEW}`);
    } else {
      navigate('/indexmanagement');
    }
  };

  const closeModalHandler = () => {
    dispatch(setConfirmModal(false));
  };
  return (
    <div
      className={
        activeStep === 2
          ? 'aur-add-edit-user create-custom-index'
          : 'aur-custom-index'
      }
    >
      <div
        className={
          activeStep === 2 ? 'header-background' : 'header-background-custom'
        }
      >
        <div className="header">
          <Box>
            <IndexBreadCrumbs
              breadCrumArray={breadCrumArray}
              title={t('indexes.customIndex.step1.createCustomIndexHeading')}
              handlePopup={handleBreadcrumbClick}
            />
            {/* <AurBreadcrumb items={breadCrumbItems} /> */}
          </Box>
          <Typography
            className="typo-text headline1_size custom-index-heading"
            component="h1"
          >
            {t('indexes.customIndex.step1.createCustomIndexHeading')}
          </Typography>

          <AurStepper
            activeStep={activeStep}
            steps={steps}
            setActiveStep={setActiveStep}
          />
        </div>

        <BackgroundImage className="background-image" aria-hidden="true" />
      </div>

      <div
        className={`${activeStep == 2 ? 'content analyzer-content' : 'content content-backgroundcolor'}`}
      >
        {activeStep == 0 ? (
          <Box id={`aur-stepper-panel-${activeStep}`}>
            <Typography className="typo-text headline3_size title">
              {t('addEditTeamMember.formTitle')}
            </Typography>
            <CustomIndexGeneralInfo
              activeStep={activeStep}
              setActiveStep={setActiveStep}
            />
          </Box>
        ) : null}
        {activeStep == 1 ? (
          <Box id={`aur-stepper-panel-${activeStep}`}>
            <>
              <Typography
                className="typo-text headline3_size mist-color-100 "
                style={{marginLeft: '160px'}}
              >
                {t('common.addMetadataFieldsNeededForIndex')}
              </Typography>
              <Typography
                className="mist-color-500  typo-text body2_size "
                marginTop={'10px'}
                marginBottom={'16px'}
                style={{marginLeft: '160px', width: '480px'}}
              >
                {t('common.customIndex1SubText')}
              </Typography>
              <Typography
                className="body2_size mist-color-500"
                marginBottom={'24px'}
                style={{marginLeft: '160px'}}
              >
                {t('common.youHaveSelected', {count: selectedFieldsCount})}
              </Typography>

              <Divider></Divider>
            </>
            <CustomIndexFormStep2 setActiveStep={setActiveStep} />
          </Box>
        ) : null}
        {activeStep == 2 ? (
          <Box id={`aur-stepper-panel-${activeStep}`}>
            <div className="analyzer-top-container">
              <div className="analyzer-top-title-container">
                <Typography className="typo-text headline3_size mist-color-100">
                  {t('analyzer.header')}
                </Typography>
                <Typography
                  className="body2_size analyzer-change-description"
                  marginBottom="24px"
                  marginTop="10px"
                  width="603px"
                >
                  {t('analyzer.description')}
                </Typography>
              </div>
            </div>
            <CutomIndexStep3
              setActiveStep={setActiveStep}
              activeStep={activeStep}
            />
          </Box>
        ) : null}
        {activeStep == 3 ? (
          <Box id={`aur-stepper-panel-${activeStep}`}>
            <div>
              <ConfigureIndexStep4 />
            </div>
          </Box>
        ) : null}
      </div>

      <div>
        <AurPopup
          className="aur-unsaved-changes-popup add-doc-confirm-popup"
          open={showPopup}
          onOk={handleContinueOptionSelected}
          onCancel={closeModalHandler}
          popupHeading={t('common.clearAllPopup.heading')}
          showPopupHeading={true}
          showPopupTitle={false}
          showCloseIcon={false}
          popupContent={
            clickedItem == '2'
              ? t('indexes.customIndex.step1.confirmMessage')
              : t('indexes.customIndex.step1.confirmEcaLink')
          }
          labelActionCancel={t('common.clearAllPopup.buttonCancel')}
          labelActionOk={t('buttons.continue')}
          exitButtonHint={t('common.clearAllPopup.cacnelToClearHint')}
          continueButtonHint={t('common.clearAllPopup.confirmToContinue')}
        />
      </div>
    </div>
  );
};

export default CustomIndexStep1;
